'use client';

import { useEffect, useState } from 'react';
import { createClient } from '@/utils/supabase/client';

/**
 * Client-side hook: non-deleted model count for a tone.
 * Returns 0 when toneId is undefined or the sentinel string 'create'
 * (i.e. the user is creating a brand-new tone in the upload/capture flow).
 */
export function useToneModelCount(toneId: number | string | undefined) {
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (toneId === undefined || toneId === 'create') {
      setCount(0);
      return;
    }

    let cancelled = false;
    setLoading(true);
    const supabase = createClient();

    supabase
      .from('models')
      .select('id', { count: 'exact', head: true })
      .eq('tone_id', Number(toneId))
      .eq('is_deleted', false)
      .then(({ count: c, error }) => {
        if (cancelled) return;
        if (error) {
          console.error('useToneModelCount:', error);
          setCount(0);
        } else {
          setCount(c ?? 0);
        }
        setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [toneId]);

  return { count, loading };
}
